import { createContext, useState, useEffect } from 'react'
import api from '../../service/api'
import { isUserLoggedIn } from '@utils'
import { handleLogout } from '@store/actions/auth'

const DEFAULT_VALUE = {
  userInfo: [],
  editarUsuario: () => { },
  handleUpdate: () => { }
}
const UserInfoContext = createContext(DEFAULT_VALUE)

const UserInfoContextProvider = ({ children }) => {
  const [data, setData] = useState({
    id: '',
    name: '',
    email: '',
    roles: '',
    created: '',
    phone: '',
    customers: ''
  })
  const [update, setUpdate] = useState(true)
  const [idUser, setIdUser] = useState('')
  const [customers, setCustomers] = useState([])
  const [customer, setCustomer] = useState({})

  const handleUpdate = () => {
    setUpdate(!update)
  }

  const editarUsuario = async params => {
    try {
      await api.put(`/users/${idUser}`, {
        ...params
      })
    } catch (e) {
      console.error(e)
    }
    setUpdate(!update)
  }

  const verifyPassword = async password => {
    try {
      const response = await api.post(`/users/verifyPassword/${idUser}`, {
        password
      })
      return response
    } catch (e) {
      console.error(e)
    }
  }
  useEffect(() => {
    ; (async () => {
      try {
        if (isUserLoggedIn()) {
          const { accessToken } = JSON.parse(localStorage.getItem('userData'))

          const { data: response } = await api.get('/authorization')
          const { data: usersData } = await api.get('/users')
          const found = usersData.find(
            element => element.email === response.email
          )
          setIdUser(found.id)
          const auth = {
            id: response.id,
            name: response.name,
            email: response.email,
            roles: response.roles,
            created: found.created_at,
            phone: found.phone,
            url_access: response.url_access,
            avatarUrl: response.avatar_url,
            customers: found.customers[0].name || null
          }
          setCustomers(response.customers)
          setCustomer(response.customers[0])
          setData(auth)
        }
      } catch (e) {
        console.error(e)
        handleLogout()
      }
    })()
  }, [update])

  return (
    <UserInfoContext.Provider
      value={{
        userInfo: data,
        customers,
        customer,
        setCustomer,
        editarUsuario,
        verifyPassword,
        handleUpdate
      }}
    >
      {children}
    </UserInfoContext.Provider>
  )
}
export { UserInfoContextProvider }
export default UserInfoContext
